import type { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import { TIMELINE_STATUS } from 'redesign/components/organisms/timeline-item/constants'
import type { Maybe, TimelineItem } from 'shared/graphql/graphql'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import type { TaskState } from '../../ContentLists/TaskList/types'
import type { GetTimelineProps } from '../../monthly-sheet-details/types'
import type { TimelineItemValues } from '../types'
import { createDefaultTimeline } from './default-timeline-factory/default-timeline-factory'
import { getIsLegacyTimeline } from './get-is-legacy-timeline'
import { createTimeLineItem } from './timeline-item-factory'
import {
  getItsMe,
  getTimelineAttributes,
  getTimelineContent,
  getTimelineReminder,
  mayAddClosedElement,
  mayAddPendingElement,
} from './utils'

export const createTimeline = ({
  task,
  t,
  locale,
  isOffice = false,
  personIds,
}: GetTimelineProps): TimelineItemValues[] => {
  const props = { task, t, locale, isOffice, personIds }
  const isLegacy = getIsLegacyTimeline(task)

  if (isLegacy) return createDefaultTimeline(props)

  const { timeline: taskTimeline } = task

  const timeline =
    taskTimeline?.reduce((acc: TimelineItemValues[], timelineItem: Maybe<TimelineItem>, _index) => {
      if (!timelineItem) return acc

      const itsMe = getItsMe({ authorId: timelineItem?.authorId ?? undefined, myPersonIds: personIds })
      const timelineAttributes = getTimelineAttributes({
        timelineItem,
        t,
        locale,
        itsMe,
        status: TIMELINE_STATUS.past,
        taskStatus: (task.statusFe as TaskState) ?? TASK_STATES.pending,
        isOffice,
      })
      const timelineContent = getTimelineContent({
        timelineItem,
        isOffice,
        formTaskUuid: timelineItem.isDataForm ? task.favurUuid ?? '' : undefined,
        task,
        t,
      })
      const reminder = getTimelineReminder({ badgeType: timelineItem.badge as TimelineItemContentBadgeTypeT, t })

      return [...acc, createTimeLineItem({ attributes: timelineAttributes, content: timelineContent, reminder })]
    }, []) ?? []

  return [...timeline, ...mayAddPendingElement(props), ...mayAddClosedElement(props)]
}
